export default __webpack_public_path__ + "static/cognizant_2-390a660a94cf5d93487c2d208dcb13cc.jpeg";